import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  addReview,
  editReview,
  fetchProductDescription,
  removeReview,
} from "./productDescriptionAPI";
import { ProductDescriptionState } from "../../../features/view/public/productDescription/productDescriptionTypes";

const initialState: ProductDescriptionState = {
  productDescription: { data: {}, loader: false },
  productDescriptionId: null,
};

export const getProductDescriptionWithCategoryAsync = createAsyncThunk(
  "productDescription/get",
  async ({
    product_id,
    anonymous_id,
  }: {
    product_id: any;
    anonymous_id: any;
  }) => {
    const response = await fetchProductDescription(product_id, anonymous_id);
    return response;
  }
);
export const addReviewAsync = createAsyncThunk(
  "review/add",
  async ({ product_id, payload }: { product_id: any; payload: any }) => {
    const response = await addReview(product_id, payload);
    return response;
  }
);
export const editReviewAsync = createAsyncThunk(
  "review/edit",
  async ({ product_id, payload }: { product_id: any; payload: any }) => {
    const response = await editReview(product_id, payload);
    return response;
  }
);

export const removeReviewAsync = createAsyncThunk(
  "review/delete",
  async (payload: any) => {
    const response = await removeReview(payload);
    return response;
  }
);

export const productDescriptionSlice = createSlice({
  name: "productDescription",
  initialState,
  reducers: {
    setSelectProduct: (state, action) => {
      state.productDescriptionId = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getProductDescriptionWithCategoryAsync.pending, (state) => {
        state.productDescription.loader = true;
      })
      .addCase(
        getProductDescriptionWithCategoryAsync.fulfilled,
        (state, action: any) => {
          state.productDescription.loader = false;
          state.productDescription.data = action?.payload?.data || [];
        }
      )
      .addCase(getProductDescriptionWithCategoryAsync.rejected, (state) => {
        state.productDescription.loader = false;
      });
  },
});
export const { setSelectProduct } = productDescriptionSlice.actions;

export default productDescriptionSlice.reducer;
